import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let timer;
    const poll = async () => {
      tries.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("failed"); return; }
      } catch (e) { /* keep polling */ }
      if (tries.current < 8) timer = setTimeout(poll, 2000);
      else setState("failed");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <main className="min-h-screen bg-[#F7F3EC] flex items-center justify-center px-6" data-testid="payment-success-page">
      <div className="bg-white border border-[#191713]/10 p-10 lg:p-14 max-w-md w-full text-center">
        {state === "checking" && (
          <>
            <Loader2 size={36} className="mx-auto text-[#A6853B] animate-spin" />
            <p className="mt-6 text-[#191713]/70" data-testid="payment-checking">{t.payment.checking}</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={40} className="mx-auto text-emerald-600" strokeWidth={1.5} />
            <h1 className="mt-6 font-serif text-2xl text-[#191713]" data-testid="payment-confirmed">{t.payment.success}</h1>
            <p className="mt-3 text-sm text-[#191713]/60">{t.payment.receipt}</p>
          </>
        )}
        {state === "failed" && (
          <p className="text-[#191713]/70" data-testid="payment-failed">{t.payment.failed}</p>
        )}
        <Link to="/portal" data-testid="payment-back-portal" className="btn-dark mt-8 w-full">{t.payment.back}</Link>
      </div>
    </main>
  );
}
